import * as React from 'react';
import { LinkButton } from '../../../../../common/LinkButton';
import { OnlyForFairPlayersWrapper } from '../OnlyForFairPlayersWrapper';
import * as styles from './OnlyForFairPlayersFatalError.css';
const sadSmileIcon = require('../../../../../../assets/sad-smile.png');

interface IOnlyForFairPlayersFatalErrorProps {
  onClickRetryButton(): void;
}

export const OnlyForFairPlayersFatalError = ({ onClickRetryButton }: IOnlyForFairPlayersFatalErrorProps) => {
  return (
    <OnlyForFairPlayersWrapper>
      <div className={styles['sad-icon-wrapper']}>
        <img src={sadSmileIcon} width={24} height={24} className={styles['sad-icon']} />
      </div>

      <span>Технические неполадки</span>

      <LinkButton marginTop={4} onClick={onClickRetryButton}>
        Попробовать ещё раз
      </LinkButton>
    </OnlyForFairPlayersWrapper>
  );
};
